/**
 * Citation ref scheme parser — shared by web + mobile ChatMessage components.
 *
 * Coach responses embed markdown links with custom ref schemes that route to
 * app screens rather than external URLs (e.g. `[Jan 5](days/2026-01-05)`).
 */
/**
 * Returns the citation scheme for a given href, or null if it is a regular URL.
 * Both web and mobile import this to detect citation links uniformly.
 */
export function parseCitationRef(href) {
    if (href.startsWith('days/'))
        return 'days';
    if (href.startsWith('week/'))
        return 'week';
    if (href.startsWith('month/'))
        return 'month';
    if (href.startsWith('entry/'))
        return 'entry';
    if (href.startsWith('metric/'))
        return 'metric';
    return null;
}
//# sourceMappingURL=citations.js.map